import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import StartModule from "./start-module";
// bao migrate - module not found: import "services/bao-template-engine";
function StartViewModel(tabPage) {
    var self = this;
    StartModule.call(self, tabPage);
    self.TabPage = tabPage;
    self.Ready = ko.observable(false);
    self.loaded = function () {
        var def = $.Deferred();
        tabPage.Title("Dashboard");
        self.registerMenuClick();
        tabPage.IsLoading(false);
        def.resolve();
        self.Ready(true);
        return def.promise();
    };
}
Bao.inherit(StartViewModel, StartModule);
StartViewModel.prototype.registerMenuClick = function () {
    var self = this;
    BaoMenu.registerEvent(function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            switch (btn.ActionKey()) {
                case "StartRefresh":
                    self.TabPage.IsLoading(true);
                    self.RefreshStart().then(function () {
                        self.TabPage.IsLoading(false);
                    });
                    break;
            }
        }
    });
};
export default StartViewModel;